import { Adapter } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider as SolanaConnectionProvider,
  WalletProvider as SolanaWalletProvider,
} from "@solana/wallet-adapter-react";
import { FC, ReactNode } from "react";

import { solanaLimiter, supportedChainsMap } from "../config";

const cluster =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? "mainnet-beta" // TODO change to "devnet" for testing
    : "mainnet-beta";

export const SolanaProvider: FC<{
  children: ReactNode;
  wallets: Adapter[];
}> = ({ wallets, children }) => {
  return (
    <SolanaConnectionProvider
      // Solana cluster environment switch
      // Use: mainnet-beta, devnet, testnet
      endpoint={supportedChainsMap.solana[cluster].rpcUrl}
      config={{
        wsEndpoint: supportedChainsMap.solana[cluster].rpcWsUrl,
        commitment: "confirmed",
        fetchMiddleware: async (info, init, fetch) =>
          solanaLimiter.schedule(async () => fetch(info, init)),
      }}
    >
      <SolanaWalletProvider
        wallets={wallets}
        autoConnect
        localStorageKey="lastSolanaConnector"
      >
        {children}
      </SolanaWalletProvider>
    </SolanaConnectionProvider>
  );
};
